import { GroupsEnum } from "@/enum/groups";
import { useMeQuery } from "@/services/user";
import { isUserAdminInGroup } from "@/utils/user";

interface PermissionGroupLike {
  group?: string;
}

const hasFullAccessGroup = (groups: unknown): boolean =>
  Array.isArray(groups) &&
  groups.some((item: PermissionGroupLike) => item?.group === GroupsEnum.ADM);

export const useCanReplaceSignedTerm = (): boolean => {
  const { data: currentUser } = useMeQuery();
  if (!currentUser) return false;
  return (
    isUserAdminInGroup(currentUser, GroupsEnum.FINANCEIRO) ||
    hasFullAccessGroup(currentUser.user_permission_group)
  );
};
